// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.template-list-container {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.template-list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.template-list-header h1 {
  margin: 0;
  color: #333;
}

.template-filters {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f5f5f5;
  border-radius: 8px;
}

.filter-group {
  display: flex;
  align-items: center;
  gap: 10px;
}

.filter-group label {
  font-weight: bold;
  color: #555;
}

.filter-group select {
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: white;
  font-size: 14px;
}

.template-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 20px;
}

.template-card {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: transform 0.2s, box-shadow 0.2s;
}

.template-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);
}

.template-card-header {
  padding: 15px;
  background-color: #f8f9fa;
  border-bottom: 1px solid #eee;
}

.template-card-header h3 {
  margin: 0 0 10px 0;
  color: #333;
  font-size: 18px;
}

.template-badges {
  display: flex;
  gap: 8px;
}

.badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: bold;
}

.badge-email {
  background-color: #e3f2fd;
  color: #1976d2;
}

.badge-sms {
  background-color: #e8f5e9;
  color: #388e3c;
}

.badge-category {
  background-color: #f3e5f5;
  color: #7b1fa2;
}

.template-card-content {
  padding: 15px;
  flex-grow: 1;
}

.template-subject {
  margin-bottom: 10px;
  font-size: 14px;
  color: #555;
}

.template-preview {
  font-size: 14px;
  color: #666;
  line-height: 1.5;
  white-space: pre-line;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.template-card-actions {
  display: flex;
  justify-content: space-between;
  padding: 15px;
  background-color: #f8f9fa;
  border-top: 1px solid #eee;
}

.btn-primary {
  background-color: #3498db;
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
  transition: background-color 0.2s;
}

.btn-primary:hover {
  background-color: #2980b9;
}

.btn-secondary {
  background-color: #f8f9fa;
  color: #333;
  border: 1px solid #ddd;
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  text-decoration: none;
  transition: background-color 0.2s;
}

.btn-secondary:hover {
  background-color: #e9ecef;
}

.btn-danger {
  background-color: #f8f9fa;
  color: #e74c3c;
  border: 1px solid #e74c3c;
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s, color 0.2s;
}

.btn-danger:hover {
  background-color: #e74c3c;
  color: white;
}

.loading {
  text-align: center;
  padding: 30px;
  color: #666;
  font-style: italic;
}

.no-templates {
  text-align: center;
  padding: 30px;
  color: #666;
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 1px dashed #ddd;
}

.error-message {
  background-color: #ffebee;
  color: #c62828;
  padding: 15px;
  border-radius: 4px;
  margin-bottom: 20px;
  border-left: 4px solid #c62828;
}
`, "",{"version":3,"sources":["webpack://./src/pages/TemplateList.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;AAChC","sourcesContent":[".template-list-container {\n  padding: 20px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.template-list-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.template-list-header h1 {\n  margin: 0;\n  color: #333;\n}\n\n.template-filters {\n  display: flex;\n  gap: 20px;\n  margin-bottom: 20px;\n  padding: 15px;\n  background-color: #f5f5f5;\n  border-radius: 8px;\n}\n\n.filter-group {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.filter-group label {\n  font-weight: bold;\n  color: #555;\n}\n\n.filter-group select {\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  background-color: white;\n  font-size: 14px;\n}\n\n.template-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));\n  gap: 20px;\n}\n\n.template-card {\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.template-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);\n}\n\n.template-card-header {\n  padding: 15px;\n  background-color: #f8f9fa;\n  border-bottom: 1px solid #eee;\n}\n\n.template-card-header h3 {\n  margin: 0 0 10px 0;\n  color: #333;\n  font-size: 18px;\n}\n\n.template-badges {\n  display: flex;\n  gap: 8px;\n}\n\n.badge {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: bold;\n}\n\n.badge-email {\n  background-color: #e3f2fd;\n  color: #1976d2;\n}\n\n.badge-sms {\n  background-color: #e8f5e9;\n  color: #388e3c;\n}\n\n.badge-category {\n  background-color: #f3e5f5;\n  color: #7b1fa2;\n}\n\n.template-card-content {\n  padding: 15px;\n  flex-grow: 1;\n}\n\n.template-subject {\n  margin-bottom: 10px;\n  font-size: 14px;\n  color: #555;\n}\n\n.template-preview {\n  font-size: 14px;\n  color: #666;\n  line-height: 1.5;\n  white-space: pre-line;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n}\n\n.template-card-actions {\n  display: flex;\n  justify-content: space-between;\n  padding: 15px;\n  background-color: #f8f9fa;\n  border-top: 1px solid #eee;\n}\n\n.btn-primary {\n  background-color: #3498db;\n  color: white;\n  border: none;\n  padding: 10px 15px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: bold;\n  transition: background-color 0.2s;\n}\n\n.btn-primary:hover {\n  background-color: #2980b9;\n}\n\n.btn-secondary {\n  background-color: #f8f9fa;\n  color: #333;\n  border: 1px solid #ddd;\n  padding: 8px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  text-decoration: none;\n  transition: background-color 0.2s;\n}\n\n.btn-secondary:hover {\n  background-color: #e9ecef;\n}\n\n.btn-danger {\n  background-color: #f8f9fa;\n  color: #e74c3c;\n  border: 1px solid #e74c3c;\n  padding: 8px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background-color 0.2s, color 0.2s;\n}\n\n.btn-danger:hover {\n  background-color: #e74c3c;\n  color: white;\n}\n\n.loading {\n  text-align: center;\n  padding: 30px;\n  color: #666;\n  font-style: italic;\n}\n\n.no-templates {\n  text-align: center;\n  padding: 30px;\n  color: #666;\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  border: 1px dashed #ddd;\n}\n\n.error-message {\n  background-color: #ffebee;\n  color: #c62828;\n  padding: 15px;\n  border-radius: 4px;\n  margin-bottom: 20px;\n  border-left: 4px solid #c62828;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
